<template>
  <div>
    <v-row class="ma-4">
      <p>Dados Técnicos da estrutura</p>
    </v-row>

    <v-row>
      <v-dialog v-model="showDialog" width="1200px">
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="showDialog = false">
              Fechar
            </v-btn>
          </v-card-actions>
          <v-card-title>
            <span class="headline">Selecionar ítem</span>
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 300px" class="text-left">Código</th>
                    <th class="text-left">Descrição</th>

                    <th class="text-right">Adicionar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in rails" v-bind:key="item.id">
                    <td>{{ item.code }}</td>
                    <td>{{ item.description }}</td>

                    <td class="text-right">
                      <v-btn class="primary" @click="addRail(index)">+</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <v-dialog v-model="showDialogAccessory" width="1200px">
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="showDialogAccessory = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
          <v-card-title>
            <span class="headline">Selecionar ítem</span>
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 300px" class="text-left">Código</th>
                    <th class="text-left">Descrição</th>

                    <th class="text-right">Adicionar</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in accessories" v-bind:key="item.id">
                    <td>{{ item.code }}</td>
                    <td>{{ item.description }}</td>

                    <td class="text-right">
                      <v-btn class="primary" @click="addAccessory(index)"
                        >+</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          v-model.number="device.structureType"
          label="Telhado"
          v-bind:options="optionsInteger"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.endRailLength"
          label="Espaço min. final do trilho (mm)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.maxLengthBetweenSupports"
          label="Espaço máx.entre suportes (mm)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.lengthBetweenModules"
          label="Espaço entre módulos (mm)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.warranty"
          label="Garantia (anos)"
          v-bind:options="optionsInteger"
        />
      </v-col>
      <br />
    </v-row>

    <v-row>
      <v-card style="width: 100%">
        <v-toolbar class="primary" dark> Trilhos </v-toolbar>
        <v-card-text>
          <v-row v-for="(item, index) in device.rails" v-bind:key="item.id">
            <v-col cols="12" md="3">
              <v-btn @click="deleteRail(index)">
                <v-icon>mdi-delete</v-icon></v-btn
              >
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="item.device.code" label="Código">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="item.device.description" label="Descrição">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="showDialog = true"> +</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row>
     <v-card style="width: 100%" >
        <v-toolbar class="primary" dark> Suportes </v-toolbar>
     

        <v-card-text>
          <v-row v-for="(item, index) in device.supports" v-bind:key="item.id">
            <v-col cols="12" md="3">
              <v-btn @click="deleteSupport(index)">
                <v-icon>mdi-delete</v-icon></v-btn
              >
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="item.device.code" label="Código">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="item.device.description" label="Descrição">
              </v-text-field>
            </v-col>

                <v-col cols="12" md="1">
            <v-text-field v-model="item.quantity" label="Quantidade">
            </v-text-field>
          </v-col>
          </v-row>

          <v-row>
            <v-spacer></v-spacer>
          <v-btn
              class="primary"
              @click="
                showDialogAccessory = true;
                selGroup = 'support';
              "
            >
              +</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>


    <v-row>
      <v-card style="width: 100%" >
        <v-toolbar class="primary" dark> Emenda de trilhos </v-toolbar>
        <!-- <v-card-text>
          <v-row v-show="device.railConnector.code">
            <v-col cols="12" md="3">
              <v-btn @click="deleteRailConnector(index)">
                <v-icon>mdi-delete</v-icon></v-btn
              >
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="device.railConnector.code" label="Código">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="device.railConnector.description"
                label="Descrição"
                v-bind:options="optionsBr"
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              class="primary"
              @click="
                showDialogAccessory = true;
                selGroup = 'railConnector';
              "
            >
              +</v-btn
            >
          </v-row>
        </v-card-text> -->

        <v-card-text>
          <v-row v-for="(item, index) in device.railConnectors" v-bind:key="item.id">
            <v-col cols="12" md="3">
              <v-btn @click="deleteRailConnector(index)">
                <v-icon>mdi-delete</v-icon></v-btn
              >
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="item.device.code" label="Código">
              </v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field v-model="item.device.description" label="Descrição">
              </v-text-field>
            </v-col>

                <v-col cols="12" md="1">
            <v-text-field v-model="item.quantity" label="Quantidade">
            </v-text-field>
          </v-col>
          </v-row>

          <v-row>
            <v-spacer></v-spacer>
          <v-btn
              class="primary"
              @click="
                showDialogAccessory = true;
                selGroup = 'railConnector';
              "
            >
              +</v-btn
            >
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>

    <v-row>
      <v-card style="width: 100%">
        <v-toolbar class="primary" dark> Acessórios </v-toolbar>

        <v-row v-for="(item, index) in device.accessories" v-bind:key="item.id">
          <v-col cols="12" md="1">
            <v-btn @click="deleteAccessory(index)">
              <v-icon>mdi-delete</v-icon></v-btn
            >
          </v-col>

          <v-col cols="12" md="2">
            <v-text-field v-model="item.device.code" label="Código">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field v-model="item.device.description" label="Descrição">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="1">
            <v-text-field v-model="item.quantity" label="Quantidade">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="1">
            <v-text-field v-model="item.parameter" label="Para cada">
            </v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-select
              class="my-5"
              v-model="item.formula"
              :items="formulaOptions"
              label="Ítem"
              item-text="text"
              item-value="value"
              dense
            >
            </v-select>
          </v-col>
        </v-row>

        <v-row class="ma-4">
          <v-spacer></v-spacer>
          <v-btn
            class="primary"
            @click="
              showDialogAccessory = true;
              selGroup = 'accessory';
            "
          >
            +</v-btn
          >
        </v-row>
      </v-card>
    </v-row>

    <v-row>
      <v-card> </v-card>
    </v-row>
  </div>
</template>



<script>
import hebelApi from "../../../../libraries/hebel/hebelApi";
export default {
  components: {},

  name: "edit-structure",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
      formulaOptions: [
        { value: 0, text: "Módulo(s)" },
        { value: 1, text: "Espaço(s) intermediário(s)" },
        { value: 2, text: "Espaço(s) final(finais)" },
        { value: 3, text: "Fileira(s)" },
      ],

      optionsBr: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 2,
      },
      optionsInteger: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      showDialogAccessory: false,
      showDialog: false,
      selected: [],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      rails: [],
      test: "test",
      accessories: [],
      selGroup: "accessory",
    };
  },

  methods: {
    searchItems() {},
    addRail(index) {
      //alert("addRail:"  + index);
      var r = Object.assign({}, this.rails[index]);
      var d = new Date();
      var rail = { deviceId: r.id, device: r, id: d.getTime() };
      this.device.rails.push(rail);

      this.showDialog = false;
    },
    deleteRail(index) {
      console.log("deleteRail");
      this.device.rails.splice(index, 1);
    },
    addAccessory(index) {
      var a = Object.assign({}, this.accessories[index]);
      var d = new Date();
      if (this.selGroup == "accessory") {
        var accessory = {
          id: d.getTime(),
          device: a,
          deviceId: a.id,
          quantity: 1,
          parameter: 4,
          formula: 0,
        };
        this.device.accessories.push(accessory);
      }
      if (this.selGroup == "support") {
        var support = {
          id: d.getTime(),
          device: a,
          deviceId: a.id,
          quantity: 1,
        };
        this.device.supports.push(support);
      }
      if (this.selGroup == "railConnector") {
      //04/06/21
       // this.device.railConnector = a;
       var railConnector = {
               id: d.getTime(),
          device: a,
          deviceId: a.id,
          quantity: 1,
       }
        this.device.railConnectors.push(railConnector);
      }

      this.showDialogAccessory = false;
    },
    deleteRailConnector(index) {
      //this.device.railConnector = {};
       this.device.railConnectors.splice(index, 1);
      this.$forceUpdate();
    },
    deleteAccessory(index) {
      this.device.accessories.splice(index, 1);
    },
    deleteSupport(index) {
      this.device.supports.splice(index, 1);
    },
  },

  async mounted() {
    //alert("mounted")
    //this.rails = await this.$dao.getDevices(window.eid, "*", "rail");
    this.rails = await hebelApi.devices.getAll("*", "rail");

    //this.accessories = await this.$dao.getDevices(window.eid, "*", "accessory");
    this.accessories = await hebelApi.devices.getAll("*", "accessory");


    if(!this.device.railConnectors)
      this.device.railConnectors =[];

    //this.devices = this.rails;
    //  alert(JSON.stringify(this.rails))
  },
};
</script>
